// theme/assets/article-project-image-grid.js
class ArticleProjectImageGrid extends HTMLElement {
  constructor() {
    super();
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  get gridButtons() {
    return this.querySelectorAll("button[data-image-index]");
  }

  get lightbox() {
    return this.querySelector('[id$="__lightbox-' + this.sectionId + '"]');
  }

  get slides() {
    return this.querySelectorAll("[data-lightbox-slide]");
  }

  get closeBtn() {
    return this.querySelector('[data-lightbox-action="close"]');
  }

  get prevBtn() {
    return this.querySelector('[data-lightbox-action="prev"]');
  }

  get nextBtn() {
    return this.querySelector('[data-lightbox-action="next"]');
  }

  connectedCallback() {
    // Add event listeners for grid buttons
    this.gridButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        const index = parseInt(btn.dataset.imageIndex, 10);
        this.open(index);
      });
    });

    // Backdrop click: close on the lightbox container itself
    this.lightbox.addEventListener("click", (e) => {
      if (e.target === this.lightbox) {
        this.close();
      }
    });

    // Event delegation for lightbox action buttons
    this.lightbox.addEventListener("click", (e) => {
      const actionBtn = e.target.closest("[data-lightbox-action]");
      if (!actionBtn) return;

      const action = actionBtn.dataset.lightboxAction;
      switch (action) {
        case "close":
          this.close();
          break;
        case "prev":
          this.goPrev();
          break;
        case "next":
          this.goNext();
          break;
      }
    });
  }

  open(index) {
    this._currentIndex = index - 1; // forloop.index is 1-based, JS is 0-based
    this.lightbox.dataset.visibility = "visible";
    this.showSlide();
    this.updateArrowVisibility();
    this.lockBodyScroll();
  }

  close() {
    this.lightbox.dataset.visibility = "hidden";
    this.unlockBodyScroll();
  }

  showSlide() {
    this.slides.forEach((slide, i) => {
      if (i === this._currentIndex) {
        slide.classList.remove("hidden");
      } else {
        slide.classList.add("hidden");
      }
    });
  }

  goNext() {
    if (this._currentIndex < this.slides.length - 1) {
      this._currentIndex++;
      this.showSlide();
      this.updateArrowVisibility();
    }
  }

  goPrev() {
    if (this._currentIndex > 0) {
      this._currentIndex--;
      this.showSlide();
      this.updateArrowVisibility();
    }
  }

  updateArrowVisibility() {
    if (this.prevBtn) {
      if (this._currentIndex === 0) {
        this.prevBtn.classList.add("hidden");
      } else {
        this.prevBtn.classList.remove("hidden");
      }
    }
    if (this.nextBtn) {
      if (this._currentIndex === this.slides.length - 1) {
        this.nextBtn.classList.add("hidden");
      } else {
        this.nextBtn.classList.remove("hidden");
      }
    }
  }

  lockBodyScroll() {
    document.body.style.overflow = "hidden";
  }

  unlockBodyScroll() {
    document.body.style.overflow = "";
  }
}

customElements.define("article-project-image-grid", ArticleProjectImageGrid);
